import { CardHeader } from './CardHeader';
import { CardContent } from './CardContent';
import { CardRoot } from './CardRoot';

export const Card = {
  Root: CardRoot,
  Header: CardHeader,
  Content: CardContent,
};
